import React from "react";

export default function ContactAndFooter() {
  const phoneNumber = "tel:+919686419682";
  const emailAddress = "mailto:autobodyworksperfect@gmail.com";
  const mapLink =
    "https://maps.app.goo.gl/JVJnnwmY1p4P7MUGA";

  const workingHours = [
    { day: "Mon", hours: "9AM – 7PM" },
    { day: "Tue", hours: "9AM – 7PM" },
    { day: "Wed", hours: "9AM – 7PM" },
    { day: "Thu", hours: "9AM – 7PM" },
    { day: "Fri", hours: "9AM – 7PM" },
    { day: "Sat", hours: "9AM – 7PM" },
    { day: "Sun", hours: "Closed" },
  ];

  return (
    <>
 <section
  id="contact"
  className="px-4 py-32 sm:py-48 text-white" // Increased top/bottom padding
>
  <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
    {/* Contact Number & Email */}
    <div className="bg-black/20 backdrop-blur-md border border-white/30 rounded-3xl px-8 py-10 flex flex-col items-center justify-center gap-4">
      <a href={phoneNumber} className="flex flex-col items-center hover:scale-105 transition">
        <h3 className="text-3xl font-bold mb-2">📞 Contact</h3>
        <p className="text-2xl">+91 9686419682</p>
        <p className="text mt-1">Both Whatsapp and Normal call</p>
      </a>
      <div className="w-full border-t border-white/20" />
      <a href={emailAddress} className="flex flex-col items-center hover:scale-105 transition">
        <h3 className="text-3xl font-bold mb-2">✉️ Email</h3>
        <p className="text-lg text-center break-all">autobodyworksperfect@gmail.com</p>
      </a>
    </div>

    {/* Location */}
    <a
      href={mapLink}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-black/20 backdrop-blur-md border border-white/30 rounded-3xl px-8 py-10 flex flex-col items-center justify-center hover:scale-105 transition"
    >
      <h3 className="text-3xl font-bold mb-2">📍 Location</h3>
      <p className="text-2xl text-center">
        Perfect Auto Body Works
        <br />
        Mangalore, Karnataka
      </p>
    </a>

    {/* Working Hours */}
    <div className="bg-black/20 backdrop-blur-md border border-white/30 rounded-3xl px-8 py-10 flex flex-col items-center justify-center">
      <h3 className="text-3xl font-bold mb-6">🕒 Working Hours</h3>
      <div className="flex flex-wrap justify-center gap-4">
        {workingHours.map((day) => (
          <div
            key={day.day}
            className="flex flex-col items-center bg-white/10 px-4 py-2 rounded-2xl"
          >
            <span className="font-semibold">{day.day}</span>
            <span className="text-sm">{day.hours}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

   <section className="bg-black/70 backdrop-blur-md text-slate-300 py-12 px-6">



      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* About / Logo */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <img
            src="/images/logo/logo.png"
            alt="Perfect Auto Body Works Logo"
            className="h-16 mb-4"
          />
          <p className="text-lg text-slate-400">
            Complete Auto Body, Mechanical & Interior Solutions for Jeeps, Cars,
            Tempo & Pick-Up Vehicles.
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col items-center text-center">
          <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
          <a href="#home" className="hover:text-white transition mb-2">
            Home
          </a>
          <a href="#services" className="hover:text-white transition mb-2">
            Services
          </a>
          <a href="#about" className="hover:text-white transition mb-2">
            About
          </a>
          <a href="#contact" className="hover:text-white transition">
            Contact
          </a>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col items-center md:items-end text-center md:text-right">
          <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
          <p className="mb-2">📞 +91 96864 19682</p>
          <p className="mb-2">✉️ autobodyworksperfect@gmail.com</p>
          <p className="mb-2">📍 Mangalore, Karnataka</p>
          <p className="mb-2">🕒 Mon – Sat: 9AM – 7PM</p>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-slate-700 mt-10 pt-6 text-center text-slate-500 text-sm">
        © {new Date().getFullYear()} Perfect Auto Body Works. All Rights Reserved.
      </div>
         </section>

         </>
   
  );
}
